import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import environment from "src/constants/environment";
import { setEarlyMeta, setEarlyTitle } from "src/early-title";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

const DEFAULT_IMAGE = `${environment.DOMAIN_URL}/default-og-image.png`;

const SEO: React.FC<SEOProps> = ({
  title = "GoodFlip Care - Personalised Support Programs",
  description = "Get personalised health support, doctor guidance and monitoring via GoodFlip Care programs.",
  keywords = "GoodFlip Care, Personalised Support Programs, Health Support, Doctor Guidance, Monitoring",
  image = DEFAULT_IMAGE,
  url = typeof window !== "undefined" ? window.location.href : "",
}) => {
  useEffect(() => {
    // EARLY DOM UPDATES — browser renders immediately
    setEarlyTitle(title);
    setEarlyMeta("description", description);
    setEarlyMeta("keywords", keywords);
    setEarlyMeta("twitter:title", title);
    setEarlyMeta("twitter:description", description);

    // Don't early-update OG tags — won't help sharing previews
  }, [title, description, keywords]);

  return (
    <Helmet>
      {/* Basic */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph (for WhatsApp, Facebook, LinkedIn) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:keywords" content={keywords} />

      {/* Twitter Cards */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:keywords" content={keywords} />
    </Helmet>
  );
};

export default SEO;
